import {ToastOptions} from 'ng2-toastr';

export class CustomToastOption {
    public 
    getErrorOptions(): any{
        let option: any = {
            showCloseButton: true,
            newestOnTop: false,
            dismiss: 'auto',
            maxShown: 10,
            toastLife: 10000}

        return option;
    }
    
    public getWarningOptions(): any{
        return this.getErrorOptions();
    }
    
    public getInfoOptions(): any{
        let option: any = {
            showCloseButton: true,
            newestOnTop: false,
            dismiss: 'auto',
            maxShown: 10,
            toastLife: 5000
         }

        return option;
    }
    
    public getSuccessOptions(): any{
        return this.getInfoOptions();
    }

    public getCustomOptions(messageCssClass: string, titleCssClass: string): any{
        let toastOption: ToastOptions = new ToastOptions();
        let option: any = {
            showCloseButton: true,
            newestOnTop: false,
            dismiss: 'click',
            maxShown: 10,
            enableHTML: true,
            messageClass:  messageCssClass,
            titleClass: titleCssClass
        }

        return option;
    }
}


// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/shared/custom-toast-options.ts